import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslate } from 'src/localization/Trns'
import { selectAppName } from 'src/redux/selectors/session.selectors'

interface AppNameProps {}

/** @deprecated
 * Use `const appName = useSelector(selectAppName); translate(appName)` instead. Do not use this component
 */
const AppName: React.FC<AppNameProps> = (): React.ReactNode => {
  const translate = useTranslate()

  const appName = useSelector(selectAppName)

  return translate(appName)
}

export default AppName
